import { makeCancelable } from 'Util/Promise';
import { prepareQuery } from 'Util/Query';
import { hash } from 'Util/Request/Hash';

import { ONE_MONTH_IN_SECONDS } from './QueryDispatcher';
import {
    checkForErrors,
    formatURI,
    getFetch,
    getGraphqlEndpoint, handleConnectionError, HTTP_201_CREATED,
    HTTP_410_GONE,
    putPersistedQuery
} from "@scandipwa/scandipwa/src/util/Request/Request";


export const parseResponse = (promise,noError) => new Promise((resolve, reject) => {
    promise.then(
        (res) => res.json().then(
            (res) => {
                if(noError){
                    resolve(res.data)
                }else {
                    resolve(checkForErrors(res))
                }
            },
            () => handleConnectionError('Can not transform JSON!') && reject()
        ),
        (err) => handleConnectionError('Can not establish connection!') && reject(err)
    );
});

export const executeGetNoError = (queryObject, name, cacheTTL,noError) => {
    const { query, variables } = queryObject;
    const uri = formatURI(query, variables, getGraphqlEndpoint());

    return parseResponse(new Promise((resolve) => {
        getFetch(uri, name).then(
            (res) => {
                if (res.status === HTTP_410_GONE) {
                    putPersistedQuery(getGraphqlEndpoint(), query, cacheTTL).then(
                        (putResponse) => {
                            if (putResponse.status === HTTP_201_CREATED) {
                                getFetch(uri, name).then(
                                    (res) => resolve(res)
                                );
                            }
                        }
                    );
                } else {
                    resolve(res);
                }
            }
        );
    }),noError);
};

/** @namespace Util/Request/DataFetcher */
export class DataFetcher {
    dataModelName = 'DataFetcher';

    componentWillUnmount() {
        if (this.promise) {
            this.promise.cancel();
        }
    }

    fetchData(rawQueries, onSuccess = () => {}, onError = () => {},noError = false) {
        const preparedQuery = prepareQuery(rawQueries);
        const { query, variables } = preparedQuery;
        const queryHash = hash(query + JSON.stringify(variables));

        if (!window.dataCache) {
            window.dataCache = {};
        }

        if (window.dataCache[queryHash]) {
            onSuccess(window.dataCache[queryHash]);

            return;
        }

        this.promise = makeCancelable(
            executeGetNoError(preparedQuery, this.dataModelName, ONE_MONTH_IN_SECONDS,noError)
        );

        this.promise.promise.then(
            /** @namespace Util/Request/DataFetcher/fetchData/thisPromisePromiseThen */
            (response) => {
                window.dataCache[queryHash] = response;
                onSuccess(response);
            },
            /** @namespace Util/Request/DataFetcher/fetchData/thisPromisePromiseCatch */
            (err) => onError(err)
        );
    }
}

export default DataFetcher;
